import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faFolder, faFolderOpen } from '@fortawesome/free-solid-svg-icons';

import Swal from 'sweetalert2';
import './CategoriasData.css';
import baseURL from '../../url';
import NewCategoria from '../NewCategoria/NewCategoria';
import NewSubCategoria from '../NewSubCategoria/NewSubCategoria';

// 🔧 Helper: construye la URL completa de la imagen
// El backend guarda rutas relativas como: uploads/categorias/bebidas/imagen.jpg
const getImageUrl = (imagen) => {
    if (!imagen) return null;
    if (imagen.startsWith('http://') || imagen.startsWith('https://')) return imagen;
    const base = baseURL.replace(/\/$/, '');
    const path = imagen.replace(/^\//, '');
    return `${base}/${path}`;
};

// 🔧 Componente: muestra imagen si carga bien, si falla muestra ícono de carpeta
const ImagenOIcono = ({ imagen, nombre, size = 32, icono, isSubcat = false }) => {
    const [error, setError] = useState(false);
    const url = getImageUrl(imagen);

    if (url && !error) {
        return (
            <img
                src={url}
                alt={nombre}
                onError={() => setError(true)}
                style={{
                    width: `${size}px`,
                    height: `${size}px`,
                    objectFit: 'cover',
                    borderRadius: isSubcat ? '4px' : '5px',
                    border: '1px solid #e2e8f0',
                    flexShrink: 0
                }}
            />
        );
    }

    return (
        <FontAwesomeIcon
            icon={icono || faFolder}
            style={{ color: '#3b82f6', fontSize: isSubcat ? '12px' : '16px' }}
        />
    );
};

export default function CategoriasData() {

    const [categorias, setCategorias] = useState([]);
    const [subcategorias, setSubCategorias] = useState([]);

    const [modalVisible, setModalVisible] = useState(false);
    const [modalVisible2, setModalVisible2] = useState(false);

    const [nuevaCategoria, setNuevaCategoria] = useState('');
    const [categoria, setCategoria] = useState({});

    const [nuevaSubCategoria, setNuevaSubCategoria] = useState('');
    const [subcategoria, setSubCategoria] = useState({});

    const [nuevaImagenCat, setNuevaImagenCat] = useState(null);
    const [previewImagenCat, setPreviewImagenCat] = useState(null);
    const [nuevaImagenSub, setNuevaImagenSub] = useState(null);
    const [previewImagenSub, setPreviewImagenSub] = useState(null);

    const [categoriaActiva, setCategoriaActiva] = useState(null);

    const toggleCategoria = (id) => {
        setCategoriaActiva(prev => prev === id ? null : id);
    };

    useEffect(() => {
        cargarCategoria();
        cargarSubCategoria();
    }, []);

    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`)
            .then(res => res.json())
            .then(data => {
                const ordenadas = (data.categorias || []).sort((a, b) => a.orden - b.orden);
                setCategorias(ordenadas);
            });
    };

    const cargarSubCategoria = () => {
        fetch(`${baseURL}/subCategoriaGet.php`)
            .then(res => res.json())
            .then(data => setSubCategorias(data.subcategorias || []));
    };

    const abrirModal = (item) => {
        setCategoria(item);
        setNuevaCategoria(item.categoria);
        setNuevaImagenCat(null);
        setPreviewImagenCat(null);
        setModalVisible(true);
    };

    const abrirModal2 = (item) => {
        setSubCategoria(item);
        setNuevaSubCategoria(item.subcategoria);
        setNuevaImagenSub(null);
        setPreviewImagenSub(null);
        setModalVisible2(true);
    };

    const eliminarImagenCategoria = async (idCategoria) => {
        const result = await Swal.fire({
            title: '¿Eliminar imagen?',
            text: 'La imagen se eliminará permanentemente.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ef4444',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });
        if (result.isConfirmed) {
            try {
                const response = await fetch(`${baseURL}/categoriaImagenDelete.php?idCategoria=${idCategoria}`, { method: 'DELETE' });
                const data = await response.json();
                if (data.mensaje || data.success) {
                    Swal.fire('Eliminada', 'La imagen ha sido eliminada', 'success');
                    cargarCategoria();
                    setModalVisible(false);
                } else {
                    Swal.fire('Error', 'No se pudo eliminar la imagen', 'error');
                }
            } catch (error) {
                Swal.fire('Error', 'Error de conexión', 'error');
            }
        }
    };

    const eliminarImagenSubcategoria = async (idSubCategoria) => {
        const result = await Swal.fire({
            title: '¿Eliminar imagen?',
            text: 'La imagen se eliminará permanentemente.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ef4444',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });
        if (result.isConfirmed) {
            try {
                const response = await fetch(`${baseURL}/subCategoriaImagenDelete.php?idSubCategoria=${idSubCategoria}`, { method: 'DELETE' });
                const data = await response.json();
                if (data.mensaje || data.success) {
                    Swal.fire('Eliminada', 'La imagen ha sido eliminada', 'success');
                    cargarSubCategoria();
                    setModalVisible2(false);
                } else {
                    Swal.fire('Error', 'No se pudo eliminar la imagen', 'error');
                }
            } catch (error) {
                Swal.fire('Error', 'Error de conexión', 'error');
            }
        }
    };

    const handleUpdateText = (idCategoria) => {
        if (nuevaImagenCat) {
            const formData = new FormData();
            formData.append('categoria', nuevaCategoria);
            formData.append('imagen', nuevaImagenCat);
            fetch(`${baseURL}/categoriaPut.php?idCategoria=${idCategoria}`, { method: 'POST', body: formData })
                .then(res => res.json())
                .then(() => { cargarCategoria(); setModalVisible(false); });
        } else {
            fetch(`${baseURL}/categoriaPut.php?idCategoria=${idCategoria}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ categoria: nuevaCategoria }),
            })
                .then(res => res.json())
                .then(() => { cargarCategoria(); setModalVisible(false); });
        }
    };

    const handleUpdateTextSubCategoria = (idSubCategoria) => {
        if (nuevaImagenSub) {
            const formData = new FormData();
            formData.append('subcategoria', nuevaSubCategoria);
            formData.append('imagen', nuevaImagenSub);
            fetch(`${baseURL}/subCategoriaPut.php?idSubCategoria=${idSubCategoria}`, { method: 'POST', body: formData })
                .then(res => res.json())
                .then(() => { cargarSubCategoria(); setModalVisible2(false); });
        } else {
            fetch(`${baseURL}/subCategoriaPut.php?idSubCategoria=${idSubCategoria}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ subcategoria: nuevaSubCategoria }),
            })
                .then(res => res.json())
                .then(() => { cargarSubCategoria(); setModalVisible2(false); });
        }
    };

    const eliminar = (id) => {
        Swal.fire({ title: '¿Seguro?', icon: 'warning', showCancelButton: true })
            .then(res => {
                if (res.isConfirmed) {
                    fetch(`${baseURL}/categoriaDelete.php?idCategoria=${id}`, { method: 'DELETE' })
                        .then(() => cargarCategoria());
                }
            });
    };

    const eliminarSubcategoria = (id) => {
        Swal.fire({ title: '¿Seguro?', icon: 'warning', showCancelButton: true })
            .then(res => {
                if (res.isConfirmed) {
                    fetch(`${baseURL}/subCategoriaDelete.php?idSubCategoria=${id}`, { method: 'DELETE' })
                        .then(() => cargarSubCategoria());
                }
            });
    };

    return (
        <div>
            <div className='deFlexContentBtns'>
                <NewCategoria />
                <NewSubCategoria />
            </div>

            <div className='table-container'>
                <div id='tbody'>
                    {categorias.map(cat => (
                        <React.Fragment key={cat.idCategoria}>

                            <div
                                className='CategoriConten'
                                onClick={() => toggleCategoria(cat.idCategoria)}
                                style={{ cursor: 'pointer' }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#000' }}>
                                    {/* 🖼 Imagen si existe, sino ícono de carpeta */}
                                    <ImagenOIcono
                                        imagen={cat.imagen}
                                        nombre={cat.categoria}
                                        size={32}
                                        icono={categoriaActiva === cat.idCategoria ? faFolderOpen : faFolder}
                                    />
                                    {cat.orden} - {cat.categoria}
                                </div>

                                <div className='tdFlex'>
                                    <button className='eliminar' onClick={(e) => { e.stopPropagation(); eliminar(cat.idCategoria); }}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                    <button className='editar' onClick={(e) => { e.stopPropagation(); abrirModal(cat); }}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                </div>
                            </div>

                            {categoriaActiva === cat.idCategoria && (
                                <div className='subCategori'>
                                    {subcategorias
                                        .filter(sub => sub.idCategoria === cat.idCategoria)
                                        .map(sub => (
                                            <div key={sub.idSubCategoria} className='CategoriConten'>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    {/* 🖼 Imagen si existe, sino ícono de carpeta */}
                                                    <ImagenOIcono
                                                        imagen={sub.imagen}
                                                        nombre={sub.subcategoria}
                                                        size={26}
                                                        icono={faFolder}
                                                        isSubcat
                                                    />
                                                    - {sub.subcategoria}
                                                </div>
                                                <div className='tdFlex'>
                                                    <button className='eliminar' onClick={() => eliminarSubcategoria(sub.idSubCategoria)}>
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                    <button className='editar' onClick={() => abrirModal2(sub)}>
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            )}

                        </React.Fragment>
                    ))}
                </div>
            </div>

            {/* MODAL EDITAR CATEGORÍA */}
            {modalVisible && (
                <div className="modal" onClick={() => setModalVisible(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <h3>Editar Categoría</h3>
                        <input value={nuevaCategoria} onChange={(e) => setNuevaCategoria(e.target.value)} />

                        {categoria.imagen && !previewImagenCat && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'flex-start' }}>
                                <img
                                    src={getImageUrl(categoria.imagen)}
                                    alt="actual"
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                    style={{ width: '100%', maxHeight: '110px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #e2e8f0' }}
                                />
                                <button type="button" className="btnDeleteImage" onClick={() => eliminarImagenCategoria(categoria.idCategoria)}>
                                    Eliminar imagen actual
                                </button>
                            </div>
                        )}

                        {previewImagenCat && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'flex-start' }}>
                                <img src={previewImagenCat} alt="preview" style={{ width: '100%', maxHeight: '110px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #e2e8f0' }} />
                                <small>Nueva imagen (pendiente de guardar)</small>
                            </div>
                        )}

                        <input type="file" accept="image/*" style={{ fontSize: '13px' }}
                            onChange={(e) => {
                                const file = e.target.files[0];
                                setNuevaImagenCat(file || null);
                                setPreviewImagenCat(file ? URL.createObjectURL(file) : null);
                            }}
                        />
                        <button onClick={() => handleUpdateText(categoria.idCategoria)}>Guardar cambios</button>
                    </div>
                </div>
            )}

            {/* MODAL EDITAR SUBCATEGORÍA */}
            {modalVisible2 && (
                <div className="modal" onClick={() => setModalVisible2(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <h3>Editar Subcategoría</h3>
                        <input value={nuevaSubCategoria} onChange={(e) => setNuevaSubCategoria(e.target.value)} />

                        {subcategoria.imagen && !previewImagenSub && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'flex-start' }}>
                                <img
                                    src={getImageUrl(subcategoria.imagen)}
                                    alt="actual"
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                    style={{ width: '100%', maxHeight: '110px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #e2e8f0' }}
                                />
                                <button type="button" className="btnDeleteImage" onClick={() => eliminarImagenSubcategoria(subcategoria.idSubCategoria)}>
                                    Eliminar imagen actual
                                </button>
                            </div>
                        )}

                        {previewImagenSub && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'flex-start' }}>
                                <img src={previewImagenSub} alt="preview" style={{ width: '100%', maxHeight: '110px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #e2e8f0' }} />
                                <small>Nueva imagen (pendiente de guardar)</small>
                            </div>
                        )}

                        <input type="file" accept="image/*" style={{ fontSize: '13px' }}
                            onChange={(e) => {
                                const file = e.target.files[0];
                                setNuevaImagenSub(file || null);
                                setPreviewImagenSub(file ? URL.createObjectURL(file) : null);
                            }}
                        />
                        <button onClick={() => handleUpdateTextSubCategoria(subcategoria.idSubCategoria)}>Guardar cambios</button>
                    </div>
                </div>
            )}

        </div>
    );
}
